import { z } from 'zod';

import { optionalSelectOption } from '@/forms/schemas/definitions';
import { BaseSelectOption } from '@/forms/types';

export const newProjectSchema = z
  .object({
    name: z.string().min(1, 'validationErrors.Required'),
    isInternalProject: z.boolean(),
    customer: optionalSelectOption(),
    billingMethod: optionalSelectOption(),
  })
  .refine((data) => data.isInternalProject || data.customer !== null, {
    message: 'validationErrors.Required',
    path: ['customer'],
  });

export type NewProjectFormValues = z.infer<typeof newProjectSchema>;

export interface NewProjectFormFields {
  name: string;
  isInternalProject: boolean;
  customer: BaseSelectOption | null;
  billingMethod: BaseSelectOption | null;
}

export const newProjectDefaultValues: NewProjectFormFields = {
  name: '',
  isInternalProject: false,
  customer: null,
  billingMethod: null,
};
